"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthoringContentClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const sdk_constants_1 = require("../../../constants/sdk.constants");
class AuthoringContentClient {
    static newInstance(options, retryOptions) {
        return new AuthoringContentClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions));
    }
    constructor(client) {
        this.client = client;
    }
    async findPrintableAssessment(assessmentTemplateId, headers) {
        const response = await this.client.get(`${sdk_constants_1.AUTHORING_API_PREFIX}/content/printableAssessment/${assessmentTemplateId}`, {
            headers,
            responseType: 'arraybuffer',
        });
        const buffer = response.body;
        return buffer;
    }
}
exports.AuthoringContentClient = AuthoringContentClient;
//# sourceMappingURL=authoring-content.client.js.map